import { getClosestConfigurationFromSeat } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import getSeatSize from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getSeatSize';
import resolveSeatColors from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/resolveSeatColors';

function compileSeatDimensions(seat) {
    const { seatConfig } = getClosestConfigurationFromSeat(seat, 'seatConfig');

    seat.compiled = {
        ...seat.compiled,
        size: getSeatSize(seatConfig),
        ...resolveSeatColors(seat),
    };

    return seat;
}

export default compileSeatDimensions;
